//place focus elsewhere. For example if a div is click put the focus in the first input
$('body').on('click', '.forceFocus', function () {
  var elem = $(this).data('focusTarget');
  if (elem) {
    $(this).find(elem).focus();
  }
});
